import React from 'react';
import { motion } from 'framer-motion';

export const GREETING =
  "Hey — I'm here to help figure out if Z37 is a fit for what you're building. What's the idea? Even half-formed counts.";

export default function GreetingMessage() {
  return (
    <motion.div
      className="message-row message-row-assistant"
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay: 0.2 }}
      data-testid="greeting-message"
    >
      <div className="message-avatar" aria-hidden="true">
        Z
      </div>
      <div className="message-bubble message-bubble-assistant">{GREETING}</div>
    </motion.div>
  );
}
